<template>
    <vMainLayout>
        <router-view />
    </vMainLayout>
</template>

<script>
import { useAsyncVuexModules } from "@/store/useAsyncVuexModules";
import tickerModule from "@/apps/ticker/store/ticker.store";
import { useAppMetadata } from "@/store/useAppMetadata";
import vMainLayout from "@/shared/views/vMainLayout.vue";

export default {
    name: "TickerApp",
    components: { vMainLayout },
    setup() {
        useAsyncVuexModules(["ticker", tickerModule]);
        useAppMetadata("ticker");
    },
};
</script>
